/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_yt_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That doesn't look like a YouTube link. Paste a full URL or an 11-character video ID.`)
};

const es_yt_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eso no parece un enlace de YouTube. Pega una URL completa o un ID de video de 11 caracteres.`)
};

const de_yt_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das sieht nicht wie ein YouTube-Link aus. Füge eine vollständige URL oder eine 11-stellige Video-ID ein.`)
};

const nl_yt_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dat lijkt geen YouTube-link. Plak een volledige URL of een video-ID van 11 tekens.`)
};

const fr_yt_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cela ne ressemble pas à un lien YouTube. Collez une URL complète ou un ID de vidéo de 11 caractères.`)
};

const it_yt_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non sembra un link YouTube. Incolla un URL completo o un ID video di 11 caratteri.`)
};

const pt_br2_yt_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Isso não parece um link do YouTube. Cole uma URL completa ou um ID de vídeo com 11 caracteres.`)
};

const pt_yt_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Isso não parece um link do YouTube. Cole um URL completo ou um ID de vídeo de 11 caracteres.`)
};

const ja_yt_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YouTubeのリンクではないようです。完全なURLか11文字の動画IDを貼り付けてください。`)
};

const zh_yt_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`这看起来不是有效的 YouTube 链接。请粘贴完整网址或 11 位视频 ID。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const yt_invalid = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.yt_invalid(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("yt_invalid", locale)
	if (locale === "en") return en_yt_invalid(inputs)
	if (locale === "es") return es_yt_invalid(inputs)
	if (locale === "de") return de_yt_invalid(inputs)
	if (locale === "nl") return nl_yt_invalid(inputs)
	if (locale === "fr") return fr_yt_invalid(inputs)
	if (locale === "it") return it_yt_invalid(inputs)
	if (locale === "pt-BR") return pt_br2_yt_invalid(inputs)
	if (locale === "pt") return pt_yt_invalid(inputs)
	if (locale === "ja") return ja_yt_invalid(inputs)
	return zh_yt_invalid(inputs)
};